import MaterialReactTable from "material-react-table";
import { Button, Card, Container, Row, Col } from "react-bootstrap";
import React, { useEffect, useCallback, useRef } from "react";
import { fetchGrossisteSite, updateGrossiste, getGrossisteSite } from "../../../Redux/grossisteReduce";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { useTranslation } from 'react-multi-lang';
import { toast, ToastContainer } from "react-toastify";
import Configuration from "../../../configuration";
import { verification } from "../../../Redux/usersReduce";
import { MRT_Localization_FR } from "material-react-table/locales/fr";
import { MRT_Localization_EN } from "material-react-table/locales/en";
import ExcelJS from 'exceljs';
import { useMemo, useState } from "react";

// core components
function ListGrossiste({ client }) {
  let lang = window.localStorage.getItem("lang");
  const t = useTranslation();
  document.title = t("Grossiste.list");
  const dispatch = useDispatch();
  const navigate = useHistory();
  var annee = localStorage.getItem("annee");
  const [entities, setEntities] = React.useState([]);
  const [loader, setLoader] = React.useState(true);
  const saveCalled = useRef(false);
  const notify = (type, msg) => {
    if (type === 1)
      toast.success(
        <strong>

          {msg}
        </strong>
      );
    else
      toast.error(
        <strong>

          {msg}
        </strong>
      );
  };
  const exportToExcel = () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Clients');

    // Define the columns based on the current table structure
    worksheet.columns = [
      { header: "Raison Sociale", key: 'Code_client' },
      { header: t("Ville"), key: 'Ville' },
      { header: t("Tel"), key: 'Tel' },
      { header: t("E-mail"), key: 'Web' },
      { header: t("Quota"), key: 'quota' },
      { header: t("Couverture"), key: 'couverture' },
      { header: t("Remise"), key: 'remise' },
    ];

    // Add rows to the worksheet
    entities.forEach(entity => {
      worksheet.addRow({
        Code_client: entity.code,
        Raison_sociale: entity.raison_sociale,
        Ville: entity.grossistes.Ville,
        Tel: entity.grossistes.Tel + (entity.grossistes.Mob.trim() !== "" ? " / " + entity.grossistes.Mob : ""),
        Web: entity.grossistes.Web,
        quota: client == "/medis" ? entity.grossistes.quota_indestrie2 : entity.grossistes.quota_indestrie3,
        couverture: client == "/medis" ? entity.grossistes.seuil_indestrie2 : entity.grossistes.seuil_indestrie3,
        remise: client == "/medis" ? entity.grossistes.remise_industrie2 : entity.grossistes.remise_industrie3,
      });
    });

    // Write the Excel file to the browser
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], { type: 'application/octet-stream' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = 'grossistes.xlsx';
      link.click();
    });
  };
  const updateListGrossiste = async () => {
    try {
      setLoader(true);

      const response = await dispatch(updateGrossiste({ client }));
      if (response.payload.msg === true) {
        notify(1, t("list_update"));
        getGrossiste();
      } else {
        notify(2, t("list_error"));
      }


    } catch (error) {
      console.error(error);
      notify(2, t("list_error"));
    } finally {
      setLoader(false);
    }
  };

  const verifToken = useCallback(async () => {
    try {
      dispatch(verification()).then(e => {
        if (e.payload === false) {
          localStorage.clear();
          window.location.replace("/login");
        }
      })
    } catch (error) {
      localStorage.clear();
      window.location.replace("/login");
    }

  }, [dispatch]);



  const [grossisteSite, setGrossisteSite] = useState({});

  function handleGrossisteSite(client) {
    dispatch(getGrossisteSite({ id_site: client == Configuration.industrie2 ? 2 : 3 })).then((e) => {
      setGrossisteSite(e.payload)
    });

  }

  const columns = useMemo(() => [
    {
      header: t("Code_client"),
      accessorKey: "code",
    },
    {
      header: t("Raison_sociale"),
      accessorKey: "raison_sociale",
    },
    {
      header: t("Ville"),
      accessorKey: "grossistes.Ville",
    },
    {
      header: t("Tel"),
      accessorKey: "Tel",
      Cell: ({ cell }) => (
        <div className="actions-right block_action">
          {cell.row.original.grossistes.Tel + (cell.row.original.grossistes.Mob.trim() != "" ? " / " + cell.row.original.grossistes.Mob : "")}

        </div>
      )

    },
    {
      header: t("E-mail"),
      accessorKey: "grossistes.Web",
    },
    {
      header: t("actions"),
      accessorKey: "id",
      Cell: ({ cell }) => (
        <div className="actions-right block_action">
          <Button
            onClick={() => {
              navigate.push(client + "/grossiste/update/" + cell.row.original.grossistes.id);
            }}
            variant="warning"
            size="sm"
            className="text-warning btn-link edit"
          >
            <i className="fa fa-edit" />
          </Button>
        </div>
      ),
    },

  ], [t]);

  function ListTable({ list, loader }) {
    return (
      <div>

        <MaterialReactTable
          state={{ isLoading: loader }}
          columns={columns}
          data={list}
          enableColumnActions={true}
          enableColumnFilters={true}
          enablePagination={true}
          enableSorting={true}
          enableBottomToolbar={true}
          enableTopToolbar={true}
          muiTableBodyRowProps={{ hover: false }}
          displayColumnDefOptions={{
            'mrt-row-numbers': {
              size: 10,
            },
            'mrt-row-expand': {
              size: 10,
            },
          }}
          enableColumnFilterModes
          initialState={{
            columnVisibility: { description: false },
            density: 'compact',
            showGlobalFilter: true,
          }}


          filterFns={{
            myCustomFilterFn: (row, id, filterValue) => {
              const value = row.getValue(id);
              return typeof value === 'string' && value.includes(filterValue);
            },
          }}
          globalFilterFn="myCustomFilterFn"

          muiSearchTextFieldProps={{
            placeholder: t("search"),
            sx: { minWidth: '18rem' },
            variant: 'outlined',
          }}
          localization={
            lang === "fr"
              ? MRT_Localization_FR
              : MRT_Localization_EN
          }
        />

      </div>
    );
  }



  const getGrossiste = useCallback(async (client) => {
    var grossiste = await dispatch(fetchGrossisteSite({client}));
    setLoader(false)
    setEntities(grossiste.payload);
  }, [dispatch]);

  useEffect(() => {
    verifToken();
    getGrossiste(client)
  }, [getGrossiste, verifToken]) //now shut up eslint
  return (
    <>
      <Container fluid>
        <ToastContainer />
        <Row>
          <Col md="12">
            <Button
              id="saveBL"
              className="btn-wd btn-info mr-1 float-right"
              type="button"
              onClick={updateListGrossiste}
            >
              <span className="btn-label">
                <i className="fas fa-sync-alt"></i>
              </span>
              {t("mise_grossiste")}
            </Button>
          </Col>
          <Col md="12">
            <Card>
              <Card.Header>
                <Card.Title as="h4"> {t("Grossiste.list")}  <Button
                  onClick={exportToExcel}
                  className="btn-export btn   export"
                >
                  Export to Excel
                </Button></Card.Title>
              </Card.Header>
              <Card.Body className="padding-0">


                <ListTable list={entities} loader={loader} ></ListTable>

              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default ListGrossiste;
